import { Injectable, inject } from '@angular/core';
import { ICustomWindow, WindowRefService } from './window-ref.service';

@Injectable({
    providedIn: 'root',
})
export class ViewService {
    private _windowRef = inject(WindowRefService);

    private get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }

    isTopInView(el: HTMLElement): boolean | undefined {
        if (!this.Window) return undefined;

        const rect = el.getBoundingClientRect();
        const topInView = rect.top - this.Window.innerHeight <= 0;

        return topInView;
    }
}
